import { render, staticRenderFns } from "./LupaPassword.vue?vue&type=template&id=50180f3d&scoped=true&"
import script from "./LupaPassword.vue?vue&type=script&lang=js&"
export * from "./LupaPassword.vue?vue&type=script&lang=js&"
import style0 from "./LupaPassword.vue?vue&type=style&index=0&id=50180f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50180f3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
